import {DocRenderer} from '@cyntler/react-doc-viewer';
import React from 'react';
import TextViewer from '../CustomViewers/TextViewer';

const base64ToUint8Array = (base64: string) => {
  const byteString = atob(base64);
  return Uint8Array.from(byteString, char => char.charCodeAt(0));
};

const detectEncoding = (bytes: Uint8Array) => {
  if (bytes.length >= 2) {
    if (bytes[0] === 0xff && bytes[1] === 0xfe) return 'utf-16le';
    if (bytes[0] === 0xfe && bytes[1] === 0xff) return 'utf-16be';
  }

  let evenNulls = 0;
  let oddNulls = 0;

  for (let index = 0; index < Math.min(bytes.length, 200); index += 1) {
    if (bytes[index] === 0) {
      if (index % 2 === 0) {
        evenNulls += 1;
      } else {
        oddNulls += 1;
      }
    }
  }

  if (oddNulls > evenNulls * 2) return 'utf-16le';
  if (evenNulls > oddNulls * 2) return 'utf-16be';

  return 'utf-8';
};

const decodeTextContent = (uri: string) => {
  const base64Content = uri.replace(/^data:text\/txt;base64,/i, '');
  const bytes = base64ToUint8Array(base64Content);
  const encoding = detectEncoding(bytes);
  const decodedText = new TextDecoder(encoding).decode(bytes);

  return decodedText.replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n');
};

const TxtRenderer: DocRenderer = ({mainState: {currentDocument}}) => {
  if (currentDocument?.uri) {
    try {
      const stringData = decodeTextContent(currentDocument.uri);
      return (
        <div>
          <TextViewer string={stringData} />
        </div>
      );
    } catch (error) {
      // Handle the error case, e.g., display an error message
      return <div>Error loading TIFF viewer</div>;
    }
  } else {
    // Handle the case where bufferData is undefined
    // For example, you might want to display a loading message or placeholder
    return <div>Loading...</div>;
  }
};

TxtRenderer.fileTypes = ['txt', 'text/plain', 'text/txt'];
TxtRenderer.weight = 1;

export default TxtRenderer;
